<template>
  <div class="jz_grade">
      <div class="title">
				<div></div>
			</div>
      <div class="image_list">
          <img v-for="(img, key) in imageList" v-lazy="img" :key="key"/>
      </div>
  </div>
</template>

<style lang="less" scoped>
  .jz_grade {
    display: block;
    width: 3.75rem;
    background-color: #FFFFFF;
    min-height: 100vh;

    .title {
			display: block;
			width: 3.75rem;
			height: 1.1rem;
			background-image: linear-gradient(270deg, #FF709B 0%, #FF4229 100%);
			overflow: hidden;

			div {
				display: block;
				width: 1.36rem;
				height: .32rem;
				background: url("~@/assets/images/jz_grade/title.png") no-repeat;
				background-size: 1.36rem .32rem;
				margin: 0 auto;
				margin-top: .24rem;
			}
    }
		.image_list {
			display: block;
			width: 100%;
			border-radius: .15rem;
			position: absolute;
			background: #FFF;
			z-index: 99;
			top: .8rem;
			overflow: hidden;

			img {
        width: 100%;
			}
		}
  }
</style>

<script>
import Vue from 'vue'
import { Lazyload } from 'vant'
Vue.use(Lazyload)

import step_1 from '@/assets/images/jz_grade/step_1.png'
import step_2 from '@/assets/images/jz_grade/step_2.png'
import step_3 from '@/assets/images/jz_grade/step_3.png'
import step_4 from '@/assets/images/jz_grade/step_4.png'
import step_5 from '@/assets/images/jz_grade/step_5.png'
import step_6 from '@/assets/images/jz_grade/step_6.png'
import step_7 from '@/assets/images/jz_grade/step_7.png'


export default {
  data() {
    return {
      imageList: [
        step_1,
        step_2,
        step_3,
        step_4,
        step_5,
        step_6,
        step_7
      ],
    }
  },
  methods: {

  }
}
</script>